import { put, takeEvery, takeLatest, select } from 'redux-saga/effects';

import CustomerAddress from '../../../models/CustomerAddress';

import { SALESFORCE_DATA_READY } from '../SFDataService/actions';

import * as Actions from './actions';

export function* populateCustomerAddress(action) {
  let address = yield select(state => state.customerAddress);
  if (action.shippingAddress !== null && action.opportunity !== null) {
    if (address === null) {
      address = new CustomerAddress(
        action.shippingAddress.getId(),
        action.shippingAddress.getStreet(),
        action.shippingAddress.getCity(),
        action.shippingAddress.getZipcode(),
        action.shippingAddress.getCountry(),
        action.opportunity.getInstallationComment(),
      );
    } else {
      address = address
        .clone()
        .setId(action.shippingAddress._id)
        .setStreet(action.shippingAddress._street)
        .setCity(action.shippingAddress._city)
        .setZipcode(action.shippingAddress._zipcode)
        .setCountry(action.shippingAddress._country)
        .setInstallationComment(action.opportunity._installationComment);
    }
  }
  yield put(Actions.customerAddressUpdated(address));
}

export function* savedCustomerAddress(action) {
  let address = new CustomerAddress()
    .setId(action.values.id)
    .setStreet(action.values.street)
    .setCity(action.values.city)
    .setZipcode(action.values.zipcode)
    .setCountry(action.values.country)
    .setInstallationComment(action.values.installationComment);

  yield put(Actions.customerAddressDataReady(address));
}

export function* customerAddressListener() {
  yield takeLatest(SALESFORCE_DATA_READY, populateCustomerAddress);
  yield takeEvery(Actions.CUSTOMER_ADDRESS_SAVED, savedCustomerAddress);
}



// WEBPACK FOOTER //
// ./src/services/DataServices/CustomerAddressService/saga.js